import { render, staticRenderFns } from "./AssetsLiabilities.vue?vue&type=template&id=5f4a6a20&scoped=true&"
import script from "./AssetsLiabilities.vue?vue&type=script&setup=true&lang=js&"
export * from "./AssetsLiabilities.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AssetsLiabilities.vue?vue&type=style&index=0&id=5f4a6a20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a6a20",
  null
  
)

export default component.exports